module.exports = __webpack_public_path__ + "static/media/marketing-campaign.94fef5d8.svg";